import styled from 'styled-components';
import { css } from 'styled-components';

export const AfterHeading = styled.div`
  font-size: 30px;
  color: ${({ theme }) => theme.colors.Grey7};
  ${({ theme }) => theme.fonts.PoppinsBold};
`;

export const BodyWrapper = styled.div`
  padding: 4rem;
  height: 100%;
`;

export const LoadingWrapper = styled.div<{ loader?: boolean }>`
  background-color: white;
  pointer-events: none;
  height: 100%;
  position: relative;
  ${({ loader }) =>
    loader &&
    css`
      opacity: 0.5;
    `};
`;

export const ADPSpinnerWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
